import { css } from 'lit';
import { createSelector } from 'reselect';
import { QueueState, SignDto } from '@typings/api';
import { AppAlert } from '@typings/shared-types';
import ConfigCARSx from '@/config/ConfigCARSx';
import { AppSection, DMSView } from '@/constants';
import { isValidNumber, isValidString } from '@/utils/utils';
import { signsSelector } from './dms/dms-selectors';

const selectAlerts = createSelector(signsSelector, (signs: SignDto[]): AppAlert[] => {
	const alerts: AppAlert[] = [];

	signs?.forEach((sign) => {
		if (
			isValidString(sign.ipAddress) &&
			sign.currentMessageState &&
			[QueueState.ERROR, QueueState.UNSENT].includes(sign.currentMessageState)
		) {
			const timeInMillis =
				(isValidNumber(sign.displayedMessageDto?.updated) && sign.displayedMessageDto?.updated > 0
					? sign.displayedMessageDto.updated
					: sign.updated) ?? Date.now();

			alerts.push({
				title: 'DMS message send error',
				category: 'ERROR',
				source: 'DMS module',
				icon: 'img/sprites.svg#icon-warning-fill',
				content: `Sign #${sign.number} failed to post message -- ${sign.currentMessageState}`,
				timeInMillis,
				actions: [
					{
						actionTitle: 'Retry message',
						icon: 'img/sprites.svg#icon-refresh',
						link: `${ConfigCARSx.Pages[AppSection.DMS].route}/${DMSView['sign-queue']}/${sign.id}`,
					},
				],
			});
		}
	});

	return alerts;
});

export default selectAlerts;
